import Domen from "../../../stores/Domen";
import GlobalState, {adddataset} from "../../../stores/GlobalState";
import Pool from "../../autorize/UserPool";


export async function GetDatasetsForPortrait({scrollRef, handleScroll, setOptionscsw }) {
    const token = localStorage.getItem("token");

    if (GlobalState.datasetflag === 0) {
        let iter = [];
        localStorage.setItem("countactivetime", Date.now());

        const response = await fetch(Domen.url + `dataset/datasets_for_portrait`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        });

        if (response.status === 200) {
            const data = await response.json();

            if (data && data.items.length > 0) {
                data.items.map((n) => {
                    const dataset = {
                        id: n.id,
                        name: n.name,
                        source: n.source,
                        last_changes: n.uploadedAt,
                        rows: n.rowsCount,
                        columns: n.columnsCount,
                        columnsName: n.columnNames,
                        object_ID: n.objectId,
                        used_in_models: n.usedInModels,
                        file_key: n.id,
                        file_name: n.file_name,
                        key_column: n.objectId,
                        status: n.status,
                        upload_time: n.uploadedAt,
                        user_id: n.user_id,
                        tag: n.tag
                    };
                    adddataset(dataset);
                    iter.push({ value: n.id, label: n.name });
                });
            }

            const element = scrollRef.current;
            if (element) {
                element.addEventListener("scroll", handleScroll);
            }

            setOptionscsw(iter);

            return () => {
                if (element) {
                    element.removeEventListener("scroll", handleScroll);
                }
            };
        } else {
            const user = Pool.getCurrentUser();

            user.getSession((err, session) => {
                if (err) {
                    console.error("Error fetching user session:", err);
                } else if (!session) {
                    console.log("No session found");
                } else {
                    const refreshToken = session.getRefreshToken();

                    user.refreshSession(refreshToken, (err, result) => {
                        if (err) {
                            console.error("Refresh error:", err);
                        } else {
                            const { accessToken } = result;
                            localStorage.setItem("token", accessToken.jwtToken);
                            getDataAttach({ scrollRef, handleScroll, setOptionscsw }); // рекурсивний виклик
                        }
                    });
                }
            });
        }
    }
}
